module.exports = __webpack_public_path__ + "img/material.ad5bba86.jpeg";